import { Layout } from '@/data/types/Layout';

export const getHelpCenterPage = (): Layout => ({
	name: 'SingleLayout',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		first: [{ name: 'HelpCenter', id: 'help-center'}],
		footer: [{ name: 'Footer', id: 'footer' }],
	},
});
